import z from "zod";

export const insightHistoryItemSchema = z.object({
	question: z.string().min(1).max(500),
	sql: z.string(),
	summary: z.string(),
});

export type InsightHistoryItemSchema = z.infer<typeof insightHistoryItemSchema>;

export const postAskInsightSchema = z.object({
	question: z.string().min(1).max(500),
	history: z.array(insightHistoryItemSchema).max(10).default([]),
});

export type PostAskInsightSchema = z.infer<typeof postAskInsightSchema>;
